export default __webpack_public_path__ + "static/sales-pipeline-f691e61844b7bb448ce4616ef862bb40.png";